import { Link, useLocation } from 'react-router-dom'
import LogoAzul from '../../Media/LogoAzul.png'
import NavbarSmResp from './NavbarSmResp'
import { Bars3Icon } from '@heroicons/react/24/outline'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import LanguageToggle from './LanguageToggle'


export default function Navbar() {

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const { t } = useTranslation('navbar')

  const { pathname } = useLocation()

  return (
    <header>
      <nav className="bg-white fixed z-50 w-full">
        <div className='
      pb-4 pt-4 shadow-md
      relative flex inset-x-0 top-0'>
          <div className='
      flex items-center gap-6 md:gap-10 lg:gap-6 xl:gap-10 2xl:gap-16 pl-6 md:pl-10
      lg:pl-8 xl:pl-10 2xl:pl-16'>
            <Link to={"/"} className='flex items-center gap-3'>
              <img
                src={LogoAzul}
                alt={t('logoAlt')}
                placeholder='blur'
                className='w-24
        md:w-32 lg:w-40'
              />
            </Link>
            <Link to={"/aboutUs"} className={`text-sm md:text-base lg:text-lg hidden lg:inline ${pathname === "/aboutUs" ? "text-navy-800" : "text-gray-600"}`}>
              {t('nosotros')}
            </Link>

            <Link to={"/soporte"} className={`text-sm md:text-base lg:text-lg hidden lg:inline ${pathname === "/soporte" ? "text-navy-800" : "text-gray-600"}`}>
              {t('soporte')}
            </Link>

            <Link to={"/catalogo"} className={`text-sm md:text-base lg:text-lg hidden lg:inline ${pathname === "/catalogo" ? "text-navy-800" : "text-gray-600"}`}>
              {t('catalogo')}
            </Link>

            <Link to={"/solutions"} className={`text-sm md:text-base lg:text-lg hidden lg:inline ${pathname === "/solutions" ? "text-navy-800" : "text-gray-600"}`}>
              {t('rfid')}
            </Link>

            <Link to={"/swrya"} className={`text-sm md:text-base lg:text-lg hidden lg:inline ${pathname === "/swrya" ? "text-navy-800" : "text-gray-600"}`}>
              {t('swrya')}
            </Link>
          </div>

          <div className='absolute inset-y-0 right-0 flex items-center pr-6 gap-4
        md:gap-6 lg:pr-8 lg:gap-4 xl:pr-10 xl:gap-6 2xl:pr-16 2xl:gap-8' >
            {/* <Bars3Icon className="h-5 w-5 lg:h-6 lg:w-6 text-gray-600 inline sm:hidden" /> */}
            <div className="flex lg:hidden">
              <button
                type="button"
                className="inline-flex items-center text-gray-600"
                onClick={() => setMobileMenuOpen(true)}
              >
                <span className="sr-only">{t('openMenu')}</span>
                <Bars3Icon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
            <LanguageToggle className="hidden lg:inline-flex" />
            <Link to={"/contact"} state="demo-swrya" className='hidden lg:inline-block rounded-lg bg-electric-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-electric-700 md:px-5 md:text-base'>
              {t('contactanos')}
            </Link>
          </div>
        </div>
      </nav>

      <NavbarSmResp mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />

    </header>
  )
}
